export default "__VITE_ASSET__BMQDpNVl__"